import React from 'react';
import { Button } from 'antd';

export const ImageOptionPanel = ({ options = [], onAddToCanvas }) => {
  return (
    <div
      style={{
        width: '100%',
        background: '#fafafa',
        display: 'flex',
        flexDirection: 'column',
        padding: 8,
        height: '100%',
        overflowY: 'auto',
      }}
    >
      {options.length === 0 ? (
        <div style={{ color: '#999', textAlign: 'center', marginTop: 20 }}>
          Sem opções
        </div>
      ) : (
        options.map(option => (
          <div
            key={option._id}
            onClick={() => onAddToCanvas(option._id, 1)}
            className="image-option-card"
            style={{
              position: 'relative',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'flex-start',
              marginBottom: 16,
              padding: 8,
              borderRadius: 6,
              boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
              cursor: 'pointer',
              transition: 'background 0.2s',
            }}
          >
            {option.image && (
              <img
                src={option.image}
                alt={option.name}
                style={{
                  width: 100,
                  height: 100,
                  objectFit: 'cover',
                  borderRadius: 4,
                  marginBottom: 8,
                }}
              />
            )}

            <div
              style={{
                fontSize: 12,
                textAlign: 'center',
                wordBreak: 'break-word',
                maxWidth: '100%',
              }}
            >
              {option.name}
            </div>

            <Button
              size="small"
              style={{
                position: 'absolute',
                top: 8,
                right: 10,
              }}
              onClick={e => {
                e.stopPropagation();
                onAddToCanvas(option._id, 1);
              }}
            >
              +
            </Button>
            {option.cost === true && (
              <Button
                size="small"
                style={{
                  position: 'absolute',
                  top: 35,
                  right: 8,
                }}
                onClick={e => {
                  e.stopPropagation();
                }}
              >
                LD
              </Button>
            )}
          </div>
        ))
      )}

      <style>
        {`
          .image-option-card {
            background: #fff;
          }
          .image-option-card:hover {
            background: #f0f0f0;
          }
        `}
      </style>
    </div>
  );
};

export default ImageOptionPanel;
